import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import ListItem from 'theme/ListItem';
import Text from "theme/Text";
import { useSelector } from "react-redux";
import i18n from "utils/i18n";
import Translate from "utils/translate";
import { buildingList } from "utils/objects/class-helper-building";
import _ from "lodash";
import { listArrow, listStyles } from "styles/list";
import { AppRoutes } from "navigations/app-routes";
import { bookingConstants } from "utils/constants/booking-constants";
import LoadingComponent from "components/atoms/Loading";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import ManagementDateSelector from "components/molecules/ManagementDateSelector";
import ThemedList from 'components/atoms/ThemedList'
import ThemedBlockListContainer from 'components/atoms/ThemedBlockListContainer'
import HelperPlatform from "utils/helper-platform";
import ObjectTimeslot from 'utils/objects/timeslot'
import { ThemedValues } from 'styles/themed'
import { colorList } from 'utils/colors'
import HelperString from 'utils/helper-string'
import { managementConstants } from 'services/redux/management/constants'
import { fetchManagementBuildingTimeslots } from 'scenes/management/bookings/_functions/timeslots'
import { useShowHamburger } from 'utils/helper-device'
import { dataConstants } from 'services/redux/data/constants'
import { selectManagementSelectedStartDate } from 'services/redux/management/reducers'
import VStack from 'components/atoms/stack/VStack'

const ManagementBookingsIndexScene = () => {
	
	const isFocused = useIsFocused();
	const route = useRoute();
	const navigation = useNavigation();
	const showHamburger = useShowHamburger()
	
	const _selectedStartDate = useSelector( selectManagementSelectedStartDate )
	const _managementBuildings = useSelector( state => {
		return state.management[managementConstants.BUILDINGS];
	} )
	const _managementFloors = useSelector( state => {
		return state.management[managementConstants.FLOORS];
	} )
	const _managementRooms = useSelector( state => {
		return state.management[managementConstants.ROOMS];
	} )
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	
	const [ loading, setLoading ] = useState( true )
	
	const eroOnly = _.get( route.params, 'eroOnly', 'no' );
	const showEroOnly = eroOnly === 'yes';
	const kind = _.get( route.params, 'kind', bookingConstants.BOOKING );
	const subKind = _.get( route.params, 'subKind', bookingConstants.BOOKING );
	const timeslotKind = _.find( _timeslotKinds, { kind: kind, sub_kind: subKind } )
	
	const fetchBuildings = () => {
		if( !isFocused ) {
			return;
		}
		
		// Only add the sub kind when custom
		let fetchSubKind = null;
		if( timeslotKind?.kind === bookingConstants.CUSTOM ) {
			fetchSubKind = subKind;
		}
		
		fetchManagementBuildingTimeslots( kind, fetchSubKind, {
			callbackStart: setLoading.bind( this, true ),
			callbackSuccess: setLoading.bind( this, false ),
			callbackError: setLoading.bind( this, false ),
		})
	}
	
	const viewItemDetails = ( building, floor = null, room = null ) => {
		const isBuilding = _.get( floor, 'isBuilding', false );
		
		let params = {
			'kind': kind,
			'subKind': subKind,
			'buildingGuid': building.guid,
			'eroOnly': eroOnly,
		};
		
		if( !isBuilding ) {
			params[ 'floorGuid' ] = floor.guid;
		}
		
		if( room !== null ) {
			params[ 'roomGuid' ] = room.guid;
		}
		
		navigation.navigate( AppRoutes.MANAGEMENT_BOOKINGS_VIEW, params );
	}
	
	const renderItem = ( building, floor ) => {
		// Filter used rooms
		const rooms = _.filter( floor.rooms, room => {
			let hasBookingForKind = false;
			
			_.forEach( ObjectTimeslot.parse( room ), ( timeslot ) => {
				timeslot = _.get( timeslot, [ 'guid' ], null );
				
				if( timeslot !== null ) {
					hasBookingForKind = true;
				}
			});
			
			return hasBookingForKind;
		})
		
		return (
			<ListItem
				key={ HelperString.hash('listItem', floor ) }
				onPress={ viewItemDetails.bind( this, building, floor ) }
				style={ [
					listStyles.listItem,
					styles.listItem
				]}>
				
				<Grid>
					<Container>
						<Column>
							<Row align={'center'} style={{ marginBottom: _.size( rooms ) > 0 ? 8 : 0 }}>
								<Column auto>
									<Text>{ Translate.field( floor, 'title' ) }</Text>
								</Column>
								<Column auto>
									{ listArrow }
								</Column>
							</Row>
							
							{ _.size( rooms ) > 0 && (
								<View
									style={styles.viewPaddingLeftMarginVertical}>
									
									<Row>
										<Column>
											<ThemedList
												data={ rooms }
												style={ styles.subList }
												renderItem={ ( { item, index } ) => {
													return renderSubItem(building, floor, item);
												} }
											/>
										</Column>
									</Row>
								</View>
							)}
						</Column>
					</Container>
				</Grid>
			</ListItem>
		)
	}
	
	const renderSubItem = ( building, floor, room ) => {
		return (
			<ListItem
				key={ HelperString.hash( 'subListItem', room ) }
				onPress={ viewItemDetails.bind( this, building, floor, room ) }
				style={ [
					listStyles.listItem,
					styles.subListItem
				]}>

				<Grid>
					<Container>
						<Column>
							<Row justify={'space-between'}>
								<Column auto={ true }>
									<Text>- { Translate.field( room, 'title' ) }</Text>
								</Column>
								<Column auto={ true }>
									{ listArrow }
								</Column>
							</Row>
						</Column>
					</Container>
				</Grid>
			</ListItem>
		);
	};
	
	useEffect( fetchBuildings, [ isFocused, _selectedStartDate] )
	
	let content = <LoadingComponent />;
	if( !loading ) {
		// Get the buildings
		//const filteredBuildings = new ClassHelperBuilding( classOptions ).getList( { filterAvailability: false, buildingTimeslotKinds: buildingTimeslotKinds } );
		const filteredBuildings = buildingList({
			buildings: _managementBuildings,
			floors: _managementFloors,
			rooms: _managementRooms,
			kinds: [ kind ]
		});
		
		// Create the content
		content = _.map( filteredBuildings, building => {
			// Variable to only show the building and not the floors/rooms
			const onlyShowBuilding = showEroOnly;
			
			// Check if there are timeslots for this floor available
			const floors = onlyShowBuilding ? [] : _.filter( building.floors, (floor) => {
				// has bookings for this kind
				let hasBookingForKind = false;

				_.forEach( ObjectTimeslot.parse( floor ), ( timeslot ) => {
					timeslot = _.get( timeslot, [ 'guid' ], null );

					if( timeslot !== null ) {
						hasBookingForKind = true;
						return false;
					}
				});
				
				if( hasBookingForKind === false ) {
					// Also check the rooms
					_.forEach( floor.rooms, room => {
						_.forEach( ObjectTimeslot.parse( room ), ( timeslot ) => {
							timeslot = _.get( timeslot, [ 'guid' ], null );
							
							if( timeslot !== null ) {
								hasBookingForKind = true;
								return false;
							}
						});
					})
				}

				return hasBookingForKind;
			});

			floors.unshift({
				isBuilding: true,
				name: i18n.t('management:generic.view_all_from', {
					name: Translate.field( building, 'title' )
				} )
			});

			return (
				<ThemedBlock
					key={ HelperString.hash( 'building-block-index', building )}
					header={ Translate.field( building, 'title' ) }
					shadow
					smallPadding>
					
					<ThemedBlockListContainer>
						<ThemedList
							data={ floors }
							renderItem={ ( { item, index } ) => {
								return renderItem(building, item);
							} }
						/>
					</ThemedBlockListContainer>
				</ThemedBlock>
			);
		});
	}
	
	let title = Translate.field( timeslotKind, 'name' )
	if( showEroOnly ) {
		title += ` (${i18n.t('management:menu.ero')})`
	}

	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ title }
				topNavigation={ true }
				topNavigationProps={{
					showHamburgerDrawer: showHamburger
				}}>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					<ThemedBlock
						overflow={ true }
						noPadding
						transparent>
						
						<ManagementDateSelector />
					</ThemedBlock>
					
					{ content }
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	viewPaddingLeftMarginVertical: {
		paddingLeft: ThemedValues.marginVertical,
	},
	container: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	menu: {
		flex: 1,
		margin: 8,
	},

	datePickerContainer: {
		alignItems: 'flex-end'
	},
	calendarPicker: {
		width: 200
	},
	listItem: {
		paddingVertical: 8,
	},
	
	subList: {
		backgroundColor: colorList.GREY.light,
		borderRadius: ThemedValues.borderRadius,
		
		...HelperPlatform.select({
			native: {
				marginLeft: ThemedValues.marginHorizontal,
				marginTop: ThemedValues.marginHorizontal,
			},
			web: {
				marginLeft: '18px',
				marginTop: '18px',
			}
		})
	},
	subListItem: {
		paddingVertical: 9
	}
});

export default ManagementBookingsIndexScene
